import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectableObservable, Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { Order } from '../order/order-new/order.model';
import { ProductGroup } from '../shared/product-group.model';
import { Product } from '../shared/product.model';
import { Supplier } from '../suppliers/supplier.model';

@Injectable()
export class SharedService {
    apiUrl = environment.apiUrl;
    statusProducts: any;
    productGroups: any;
    products: Array<Product>;
    productsWithInactive: Array<Product>;
    suppliers: any;
    finishedOrders: any;
    openOrders: any;
    openOrdersLength: any;
    filteredOrders: any;
    selectedProductGroup;
    shoppingCart = [];
    editingShoppingCart = [];
    storageCartLength;
    public env: any;

    constructor(private http: HttpClient) {
        this.env = this.getEnv();
    }

    allowOnlyNumbers(event: any) {
        const pattern = /^\d+$/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    getFinishedOrders(limit?: number, search?: string): Observable<Order> {
        const orderLimit = limit ? limit : 100;
        if (!limit && this.finishedOrders) {
            return Observable.of(this.finishedOrders);
        } else {
            const url = search ? this.apiUrl + '/cp/shippingorders/finishedorders/' + orderLimit + '/' + search + '?system=kp' : this.apiUrl + '/cp/shippingorders/finishedorders/' + orderLimit + '?system=kp';
            return this.http.get<Order>(url).do(res => {
                this.finishedOrders = res['ordrer'];
            });
        }
    }

    getOpenOrders(): Observable<Order> {
        if (this.openOrders) {
            return Observable.of(this.openOrders);
        } else {
            return this.http.get<Order>(this.apiUrl + '/cp/shippingorders/orders?system=kp&available=3').do(res => {
                this.openOrders = res['ordrer'];
                this.openOrdersLength = Object.keys(res['ordrer']).length;
            });
        }
    }

    getSuppliers(): Observable<Supplier> {
        if (this.suppliers) {
            return Observable.of(this.suppliers);
        } else {
            return this.http.get<Supplier>(this.apiUrl + '/cp/getSuppliers').do(res => {
                this.suppliers = res;
            });
        }
    }

    getOrderByOrderNmbr(orderNmbr: string): Observable<Order> {
        return this.http.get<Order>(this.apiUrl + '/cp/shippingorders/order/' + orderNmbr);
    }

    searchOrderByNmbr(orderNmbr: string): Observable<Order> {
        return this.http.get<Order>(this.apiUrl + '/cp/shippingorders/ordreSoek/' + orderNmbr);
    }

    getProductGroups(): Observable<ProductGroup> {
        if (this.productGroups) {
            return Observable.of(this.productGroups);
        } else {
            this.productGroups = JSON.parse(localStorage.getItem('groups'));

            return this.http.get<ProductGroup>(this.apiUrl + '/products/groups').do(res => {
                if (res && this.productGroups !== res) {
                    localStorage.setItem('groups', JSON.stringify(res));
                    this.productGroups = res;
                }
            });
        }
    }

    getAllProducts(): Observable<Array<Product>> {
        if (this.products) {
            return Observable.of(this.products);
        } else {
            const request: ConnectableObservable<Array<Product>> = this.http
                .get<Array<Product>>(this.apiUrl + '/cp/products/all')
                .do(res => {
                    this.products = res;
                })
                .publish();
            request.connect();
            return request;
        }
    }

    getAllProductsWithInactive(): Observable<Array<Product>> {
        if (this.productsWithInactive) {
            return Observable.of(this.productsWithInactive);
        } else {
            return this.http.get<Array<Product>>(this.apiUrl + '/cp/products/withInactive').do(res => {
                this.productsWithInactive = res;
            });
        }
    }

    reportVareStatusProdukt(): Observable<Product> {
        if (this.statusProducts) {
            return Observable.of(this.statusProducts);
        } else {
            return this.http.get<Product>(this.apiUrl + '/reports/varestatus/produkt').do(res => {
                this.statusProducts = res;
            });
        }
    }

    selectProductGroup(id): Observable<any> {
        for (const group in this.productGroups) {
            if (this.productGroups[group].produktgruppe_id === id) {
                this.selectedProductGroup = this.productGroups[group];
                return Observable.of(this.selectedProductGroup);
            }
        }
    }

    filterOpenOrders(status): Observable<any> {
        const arr = [];
        for (let i = 0; i < Object.keys(this.openOrders).length; i++) {
            if (status !== '') {
                if (this.openOrders[i].status === status) {
                    arr.push(this.openOrders[i]);
                }
            } else {
                arr.push(this.openOrders[i]);
            }
        }
        this.filteredOrders = arr;
        return Observable.of(this.filteredOrders);
    }

    public getAllReports() {
        const allReports: any = [
            {
                name: 'Retur statuser',
                value: 'returstatus',
                data: 'null'
            },
            {
                name: 'Varestatus',
                value: 'varestatus',
                data: 'null'
            },
            {
                name: 'Ordre Oversikt',
                value: 'ordreoversikt',
                data: 'null'
            },
            {
                name: 'On Hold',
                value: 'onhold',
                data: 'null'
            }
            // ,
            // {
            //     name: 'Retur Uttrekk',
            //     value: 'returuttrekk',
            //     data: 'null'
            // }
        ];

        return allReports;
    }

    public getEnv(): Observable<any> {
        return this.http.get(this.apiUrl + '/info/devstatus');
    }

    public updateStorageCart() {
        localStorage.setItem('shoppingCart', JSON.stringify(this.shoppingCart));
        this.getStorageCart();
    }
    public saveOrderDetailsLs(data) {
        localStorage.setItem('orderDetails', JSON.stringify(data));
    }
    public getStorageCart() {
        if (localStorage.getItem('shoppingCart')) {
            this.storageCartLength = JSON.parse(localStorage.getItem('shoppingCart')).length;
            return JSON.parse(localStorage.getItem('shoppingCart'));
        } else {
            return false;
        }
    }

    public getStorageOrderDetails() {
        if (localStorage.getItem('orderDetails')) {
            return JSON.parse(localStorage.getItem('orderDetails'));
        } else {
            return false;
        }
    }

    public deleteOrderDetails() {
        localStorage.removeItem('orderDetails');
    }

    public changeProductStatus(prod) {
        prod.aktiv = prod.aktiv === false ? 0 : 1;
        return this.http.post(this.apiUrl + '/cp/products/changeStatus', prod);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts